import React from 'react'
import { connect } from 'react-redux'
import { Menu, MenuItem, IconButton, Button, Hidden } from '@material-ui/core';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import { makeStyles } from '@material-ui/core/styles';
import { history } from '../../routers/AppRouter'
import { startLogout } from '../../actions/userAction'
import { openAuthModal } from '../../actions/metaAction'


const useStyles = makeStyles((theme) => ({
    avatar: {
        backgroundColor: theme.palette.secondary.main, height: '30px', width: '30px',
        color: theme.palette.primary.main
    },
    link: {
        textDecoration: 'none',
        color: theme.palette.primary.main
    },
    border: {
        fontFamily: 'inherit',
        '& > * > ul': {
            border: '1px solid #e2e2e2'
        }
    }
}));

const AvatarWidget = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null)

    function onMenuClose() {
        setAnchorEl(null)
    }

    function onMenuOpen(e) {
        setAnchorEl(e.target)
    }

    const classes = useStyles();

    return (
        <React.Fragment>
            {
                props.isAuthenticated ?
                    <React.Fragment>
                        <IconButton aria-controls="profile-menu" color="primary" aria-haspopup="true" onClick={onMenuOpen}>
                            <AccountCircleOutlinedIcon color="secondary" />
                        </IconButton>
                        <Menu
                            className={classes.border}

                            id="simple-menu"
                            elevation={4}
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={onMenuClose}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}

                        >
                            <MenuItem onClick={() => { history.push('/profile'); onMenuClose() }}>Profile</MenuItem>
                            <MenuItem onClick={() => { history.push('/address-book'); onMenuClose() }}>Address Book</MenuItem>
                            <MenuItem onClick={() => { history.push('/live-orders'); onMenuClose() }}>Live Orders</MenuItem>
                            <MenuItem onClick={() => { history.push('/past-orders'); onMenuClose() }}>Order History</MenuItem>
                            <MenuItem onClick={props.startLogout}>Logout</MenuItem>
                        </Menu>

                    </React.Fragment>
                    :
                    <Button style={{ color: '#fff' }} startIcon={<AccountCircleOutlinedIcon color="secondary" />} onClick={props.openAuthModal}>
                        <Hidden smDown>
                            Login
                        </Hidden>
                    </Button>
            }
        </React.Fragment>
    )

}

const mapStateToProps = (state) => {

    return {
        profile: state.user.profile,
        isAuthenticated: state.user.isAuthenticated
    }
}

export default connect(mapStateToProps, { startLogout, openAuthModal })(AvatarWidget)
